import React from 'react';

/**
 * ErrorBoundary minimal pour capter les erreurs de rendu dans l'arbre Pulse.
 * Affiche le stack exact dans la console pour diagnostic.
 */
export default class PulseErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error('🔴 [PulseErrorBoundary] caught:', err, info?.componentStack);
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-[#F5F1EA] flex items-center justify-center p-8">
          <div className="max-w-xl bg-white border border-[#E5DFD0] rounded-2xl p-8 text-[#1F1A12]">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#B94A48] font-semibold mb-2">
              Erreur dashboard Pulse
            </div>
            <h2 className="font-serif text-2xl mb-3">Impossible de charger cette vue.</h2>
            <p className="text-sm text-[#6B5E48] mb-4">
              Une erreur est survenue pendant le rendu. L'équipe technique a été notifiée.
            </p>
            <pre className="text-[10px] bg-[#FAF5EA] border border-[#E5DFD0] rounded p-3 overflow-auto max-h-48 text-[#B94A48]">
              {String(this.state.err?.message || this.state.err)}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
